export default __webpack_public_path__ + "static/media/student-video-on.14892685.svg";